"use client";

import { Badge } from "@tillix/ui-atoms/badge";
import { cn } from "@tillix/ui-atoms/lib/utils";
import { type AppointmentKey, useAppointmentT } from "../i18n/use-t";
import { isActionableStatus } from "../lib/status";
import type { OrderStatus } from "../types";

function statusVariant(
  status: string,
): React.ComponentProps<typeof Badge>["variant"] {
  if (status === "CNCL" || status === "MSFE") return "error";
  if (status === "CMPL") return "success";
  if (isActionableStatus(status)) return "secondary";
  return "info";
}

export const StatusBadge: React.FC<{
  status: OrderStatus;
  size?: React.ComponentProps<typeof Badge>["size"];
}> = ({ status, size = "sm" }) => {
  const t = useAppointmentT();
  return (
    <Badge
      className={cn(
        isActionableStatus(status) ? "text-white" : "",
        "font-bold uppercase tracking-wide",
      )}
      size={size}
      variant={statusVariant(status)}
    >
      {t(`status.${status}` as AppointmentKey, { defaultValue: status })}
    </Badge>
  );
};
